import React from "react";
import PropTypes from "prop-types";
import range from "lodash/range";
import getDate from "date-fns/getDate";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import isBefore from "date-fns/isBefore";
import isAfter from "date-fns/isAfter";
import lastDayOfMonth from "date-fns/lastDayOfMonth";

import Icon from "../icon/icon";
import Select from "../select/select";
import { ArrowRight } from "../../lib/icons";
import Tooltip from "../tooltip/tooltip";
import { isYearDisabled, isMonthDisabled } from "./datepickerUtils";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

class DatePickerHeader extends React.Component {
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(props) {
    const { date: lastDate, minDate, maxDate, changeMonth } = this.props;
    const lastYear = getYear(lastDate);
    const { date } = props;
    const month = getMonth(date);
    const year = getYear(date);

    if (lastYear !== year) {
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(
        year,
        month,
        getDate(lastDayOfMonth(new Date(year, month, 1)))
      );
      if (isBefore(lastDay, minDate)) {
        changeMonth(getMonth(minDate));
      } else if (isAfter(firstDay, maxDate)) {
        changeMonth(getMonth(maxDate));
      }
    }
  }

  render() {
    const {
      minDate,
      maxDate,
      startYear,
      endYear,
      date,
      changeYear,
      changeMonth,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled
    } = this.props;

    const years = range(startYear, endYear, 1);

    const LeftArrow = (
      <Icon
        src={ArrowRight}
        clickable={!prevMonthButtonDisabled}
        inactive={prevMonthButtonDisabled}
        onClick={!prevMonthButtonDisabled ? decreaseMonth : null}
        className="react-datepicker__header__custom__decrease-month"
      />
    );

    const RightArrow = (
      <Icon
        src={ArrowRight}
        clickable={!nextMonthButtonDisabled}
        inactive={nextMonthButtonDisabled}
        onClick={!nextMonthButtonDisabled ? increaseMonth : null}
        className="react-datepicker__header__custom__increase-month"
      />
    );

    return (
      <div className="react-datepicker__header__custom">
        <div className="react-datepicker__header__custom__month-year-name">
          {prevMonthButtonDisabled ? (
            LeftArrow
          ) : (
            <Tooltip text="Previous Month">{LeftArrow}</Tooltip>
          )}

          <h6>
            {months[getMonth(date)]} {getYear(date)}
          </h6>
          {nextMonthButtonDisabled ? (
            RightArrow
          ) : (
            <Tooltip text="Next Month">{RightArrow}</Tooltip>
          )}
        </div>
        <div className="react-datepicker__header__custom__month-year-dropdown">
          <Select
            name="react-datepicker-month-dp"
            className="react-datepicker__header__custom__month-dp"
            type="select"
            options={months.map(month => ({
              label: String(month),
              value: month,
              isDisabled: isMonthDisabled(
                minDate,
                maxDate,
                months.indexOf(String(month)),
                getYear(date),
                startYear,
                endYear
              )
            }))}
            onChange={month => {
              changeMonth(months.indexOf(month.value));
            }}
            value={{
              label: String(months[getMonth(date)]),
              value: months[getMonth(date)]
            }}
            isDisabled={prevMonthButtonDisabled && nextMonthButtonDisabled}
          />
          <Select
            name="react-datepicker-year-dp"
            className="react-datepicker__header__custom__year-dp"
            type="select"
            options={years.reverse().map(year => ({
              label: String(year),
              value: year,
              isDisabled: isYearDisabled(
                minDate,
                maxDate,
                year,
                startYear,
                endYear
              )
            }))}
            onChange={year => {
              changeYear(year.value);
            }}
            value={{ label: String(getYear(date)), value: getYear(date) }}
            isDisabled={prevMonthButtonDisabled && nextMonthButtonDisabled}
          />
        </div>
      </div>
    );
  }
}

DatePickerHeader.propTypes = {
  startYear: PropTypes.number,
  endYear: PropTypes.number,
  date: PropTypes.instanceOf(Date),
  changeYear: PropTypes.func,
  changeMonth: PropTypes.func,
  decreaseMonth: PropTypes.func,
  increaseMonth: PropTypes.func,
  prevMonthButtonDisabled: PropTypes.bool,
  nextMonthButtonDisabled: PropTypes.bool,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date)
};

DatePickerHeader.displayName = "OrionDatePickerHeader";

export default DatePickerHeader;
